module.exports = __webpack_public_path__ + "static/img/cn.51c28296.svg";